import { render } from "./cookie-policy.vue?vue&type=template&id=09ff1093&scoped=true&ts=true"
import script from "./cookie-policy.vue?vue&type=script&lang=ts"
export * from "./cookie-policy.vue?vue&type=script&lang=ts"

import "./cookie-policy.vue?vue&type=style&index=0&id=09ff1093&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ff1093"]])

export default __exports__